module.exports = __webpack_public_path__ + "img/index4.c3f8e800.png";